import { jsx as _jsx } from "react/jsx-runtime";
import { G, SVG } from '../svg';
import { defaultPropTypes } from './default-prop-types';
export const CloseIcon = props => {
    const { appearance, fill, ...rest } = props;
    return (_jsx(SVG, { ...rest, viewBox: "0 0 24 24", children: _jsx(G, { appearance: appearance, color: fill, children: _jsx("path", { d: "M20.749 4.707l-1.415-1.414-7.292 7.293-7.293-7.293-1.415 1.414L10.627 12l-7.293 7.293 1.415 1.414 7.293-7.293 7.292 7.293 1.415-1.414L13.456 12z" }) }) }));
};
CloseIcon.propTypes = defaultPropTypes;
CloseIcon.isPrivate = true;
export default CloseIcon;
